<div class="flex flex-col items-center" [formGroup]="form">
  <p class="typo-h3-light mb-[14px]">{{ toothPosition() || '' }}</p>
  <p class="typo-h6-light mb-1">{{ surfaceTranslationKey() | translate }}</p>
  <lib-input
    #surfaceInput
    class="flex !h-10 !w-10 items-center justify-center"
    type="number"
    formControlName="surface"
    [activeCursorHint]="true"
    [activeCursorHintColor]="'purple'"
    [activeCursorNextStroke]="true"
    [hideCaret]="true"
  ></lib-input>
</div>
